import { useState } from 'react';
import useAPI from '../../../../hooks/useAPI';

export const INTERESSADOS_MBA_FILTERS = {
  NOME: 'nome',
  EMAIL: 'email',
  DATA_INICIO: 'data_inicio',
  DATA_FIM: 'data_fim',
  REMOVE_TEST: 'remove_test',
  ONLY_PAID: 'only_paid',
  ONLY_ASSIGNED: 'only_assigned'
}

const buildMBAUrl = ({ baseUrl, page, rowsPerPage, filters }) => {
  const query = {
    page: page + 1,
    limit: rowsPerPage,
    ...(filters?.[INTERESSADOS_MBA_FILTERS.NOME] && { nome: filters[INTERESSADOS_MBA_FILTERS.NOME] }),
    ...(filters?.[INTERESSADOS_MBA_FILTERS.EMAIL] && { email: filters[INTERESSADOS_MBA_FILTERS.EMAIL] }),
    ...(filters?.[INTERESSADOS_MBA_FILTERS.DATA_INICIO] && { data_inicio: filters[INTERESSADOS_MBA_FILTERS.DATA_INICIO] }),
    ...(filters?.[INTERESSADOS_MBA_FILTERS.DATA_FIM] && { data_fim: filters[INTERESSADOS_MBA_FILTERS.DATA_FIM] }),
    ...(filters?.[INTERESSADOS_MBA_FILTERS.REMOVE_TEST] && { remove_test: true }),
    ...(filters?.[INTERESSADOS_MBA_FILTERS.ONLY_PAID] && { only_paid: true }),
    ...(filters?.[INTERESSADOS_MBA_FILTERS.ONLY_ASSIGNED] && { only_assigned: true }),
  }

  const queryParams = new URLSearchParams(query);

  return `${baseUrl}?${queryParams.toString()}`;
}

export default function useInteressadosMBA() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [filters, setFilters] = useState({});

  const { data, headers, isLoading, refreshData } = useAPI(buildMBAUrl({ baseUrl: '/admin/aluno/mba-index', page, rowsPerPage, filters }));

  const changePage = (newPage) => {
    setPage(newPage);
  }

  const changeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    changePage(0);
  }

  const changeFilters = (newFilters) => {
    setFilters(newFilters);
    changePage(0);
  }

  const resetFilters = () => {
    changeFilters({});
  }

  return {
    data,
    total: headers?.['x-total-count'],
    isLoading,
    page,
    rowsPerPage,
    filters,
    changePage,
    changeRowsPerPage,
    changeFilters,
    resetFilters,
    refreshData
  };
}